import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
import DefaultChip from "../Chip";
import { DefaultCombobox, DefaultComboboxItem, } from "../Combobox/DefaultCombobox";
// @ts-ignore
const ComponentCtx = createContext(undefined);
const defaultComboboxRootStyle = {};
const ComponentProvider = ({ children, chipComponent = DefaultChip, comboboxComponent = DefaultCombobox, comboboxRootStyle = defaultComboboxRootStyle, comboboxItemComponent = DefaultComboboxItem, }) => {
    return (_jsx(ComponentCtx.Provider, Object.assign({ value: {
            chipComponent,
            comboboxComponent,
            comboboxRootStyle,
            comboboxItemComponent,
        } }, { children: children })));
};
export default ComponentProvider;
export { ComponentCtx };
